import io from 'socket.io-client';
import IDriver from '../../NativeDevice/Front/IFrontDriver';
import SocketSynchronizer from './SocketSynchronizer';

export function createSocketSynchronizer(serverUri: string, getNativeDriver: () => IDriver) {
	return new SocketSynchronizer(getNativeDriver, (ioServerUri: string) => io(ioServerUri), serverUri);
}
